import React from 'react';
import { Box, Button, Divider, IconButton, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import LearnifyLogo from "../../assets/images/LearnifyLogoLight.png"
import LearnifyLogoShort from "../../assets/images/LearnifyLogoShort.png"
import LogoutIcon from '@mui/icons-material/PowerSettingsNew';

const Sidebar = (props) => {
  
  const {navigationItems, MiniDrawer, toggleDrawer, openDrawer,  handleLogout} = props;

  return (
    <>
        <MiniDrawer variant="permanent" open={openDrawer}>
            <Box sx={{
                display: openDrawer ? 'flex' : 'contents',
                justifyContent: openDrawer ? 'space-between' : '',
                flexDirection: openDrawer ? 'row' : '',
                alignItems: 'center',
                }}
            >
                {openDrawer ? <Box component="img" src={LearnifyLogo} alt="logo" style={{width: '100px', alignSelf: 'center', marginLeft:'10px' }}/> : <>
                <Box component="img" src={LearnifyLogoShort} alt="logo" style={{width: '50px', alignSelf: 'center', padding: '4px', marginTop: '10px' }}/>
                </>}
                <IconButton color="inherit" onClick={toggleDrawer} edge="start" sx={{ marginRight: 2, display: 'flex', justifyContent: 'center', alignSelf: openDrawer ? 'center' : 'flex-end' }}>
                    {openDrawer ? <ChevronLeftIcon sx={{color: 'white', alignSelf: 'center', margin: '0px'}}/> : <MenuIcon sx={{color: 'white', alignSelf: 'flex-end', margin: '0px'}}/>}
                </IconButton>
            </Box>
            <Divider/>
            <List sx={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
            {/* Navigation Items */}
            {navigationItems?.map((item, index) => (
                <ListItem button key={index} onClick={item.onClick} sx={{display: 'flex', justifyContent: 'center', cursor: 'pointer'}}>
                <ListItemIcon sx={{display: 'flex', justifyContent: 'center'}}>{item.icon}</ListItemIcon>
                {openDrawer && <ListItemText primary={item.text} sx={{color: 'white'}}/>}
                </ListItem>
            ))}
            </List>
            <Button color="inherit" onClick={handleLogout} sx={{fontSize: '16px', gap: '4px', color: 'white', bottom: '0px', display: 'flex', position: 'absolute', alignSelf: 'center', fontWeight: '600', textTransform: 'capitalize', display: 'flex', width: '100%', justifyContent: 'flex-start', padding: '8px 16px'}}>
            {openDrawer ? (
            <>
                <LogoutIcon sx={{minWidth: '56px'}}/> Logout
            </>
            ) : (
            <LogoutIcon />
            )}
            </Button>
            
      </MiniDrawer>
    </>
  )
}

export default Sidebar;